import PaymentEntryService from './PaymentEntryService'
import PaymentEntryRoutes from './route-types'
import StoreUtil from '@/store/utils'
import DeepDiff from 'deep-diff'

const tag = 'paymententry'

const state = {
  returnRoute: {},
  baseIndex: 0,
  currentIndex: 0,
  snapshots: [],
  readOnlyView: false
}

const getters = {
  returnRoute: state => state.returnRoute,
  snapshots: state => state.snapshots,
  baseSnapshot: state => state.snapshots[state.baseIndex],
  currentSnapshot: state => state.snapshots[state.currentIndex],
  snapshotDiff: state => {
    if (state.snapshots[state.baseIndex] && state.snapshots[state.currentIndex]) {
      return DeepDiff.diff(state.snapshots[state.baseIndex], state.snapshots[state.currentIndex])
    } else {
      return null
    }
  },
  readOnlyView: state => state.readOnlyView
}

const actions = {
  async getStoreItem({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity) {
      const data = await PaymentEntryService.getEntity(id)
      if (data) {
        console.log('from WebApi')
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    // StoreUtil.setStorage(entity.creditorPaymentID, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async getStoreItemPaymentEntry({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    //if (!entity || (entity && !entity.isNew)) {
    if (!entity) {
      const data = await PaymentEntryService.getEntityPaymentEntry(id)
      if (data) {
        console.log('from WebApi')
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    StoreUtil.setStorage(entity.vendorId, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async editStoreItemByInvoiceId({ commit }, id) {
    let entity = StoreUtil.getStorage(id, tag)
    if (!entity) {
      const data = await PaymentEntryService.getAdvancePaymentByInvoiceId(id)
      if (data) {
        console.log('from WebApi')
        entity = data
      } else {
        console.log('from sessionStorage')
      }
    }
    // StoreUtil.setStorage(entity.creditorPaymentID, tag, entity)
    commit('saveInitialSnapshots', entity)
  },
  async editStoreItem({ commit }, id) {
    // const entity = StoreUtil.getStorage(id, tag) || (await PaymentEntryService.getEntity(id))
    const entity = await PaymentEntryService.getEntity(id)
    // StoreUtil.setStorage(entity.creditorPaymentID, tag, entity)
    commit('saveInitialSnapshots', entity)
    // StoreUtil.routeToDetail(PaymentEntryRoutes.PaymentEntryListView.path, entity.vendorId, false)
  },
  async editStoreItemPaymentEntry({ commit }, id) {
    const entity = StoreUtil.getStorage(id, tag) || (await PaymentEntryService.getPaymentEntryByPaymentId(id))
    StoreUtil.setStorage(entity.vendorId, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(PaymentEntryRoutes.PaymentEntryListView.path, entity.vendorId, false)
  },
  async addStoreItem({ commit }) {
    const entity = await PaymentEntryService.getNewEntity()
    const utcDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()).toISOString()
    entity.payDate = utcDate.split('.')[0] + 'Z'
    StoreUtil.setStorage(entity.creditorPaymentID, tag, entity)
    commit('saveInitialSnapshots', entity)
    return entity
  },
  async addStoreItemPaymentEntry({ commit }, vendorId) {
    const entity = await PaymentEntryService.getNewEntityPaymentEntry(vendorId)
    StoreUtil.setStorage(entity.vendorId, tag, entity)
    commit('saveInitialSnapshots', entity)
    StoreUtil.routeToDetail(PaymentEntryRoutes.PaymentEntryListView.path, entity.vendorId, true)
  },
  saveSnapshot({ commit }, entity) {
    commit('saveSnapshot', entity)
  },
  clearSnapshots({ commit }, id) {
    StoreUtil.removeStorage(id, tag)
    commit('clearSnapshots')
  },
  setReturnRoute({ commit }, route) {
    commit('setReturnRoute', route)
  },
  setReadOnlyView({ commit }, value) {
    commit('setReadOnlyView', value)
  }
}

const mutations = {
  saveInitialSnapshots(state, entity) {
    state.snapshots = []
    state.snapshots.splice(0, 1, entity)
    state.snapshots.splice(1, 1, entity)
    state.currentIndex = state.snapshots.length - 1
  },
  saveSnapshot(state, entity) {
    state.snapshots.splice(state.currentIndex, 1, entity)
  },
  clearSnapshots(state) {
    state.snapshots = []
    state.baseIndex = 0
    state.currentIndex = 0
  },
  setReturnRoute(state, route) {
    state.returnRoute = route
  },
  setReadOnlyView(state, value) {
    state.readOnlyView = value
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
